import React, { useState, useEffect } from 'react';
import { Button, Table } from 'antd';
import { TablePaginationConfig } from 'antd/lib/table';
import type { TableProps } from 'antd';
import emiter, {
	EVENT_CARRENTAL_ROLE_SEARCH_LIST,
	EVENT_CARRENTAL_ROLE_OPEN_DETAIL,
	EVENT_CARRENTAL_ROLE_OPEN_EMPLOYEE,
} from '../../../../events';
import { getRoleList } from '../../../../hooks/carRental/employee';
import SPButton from "../../base/SPButton";

interface TableUserListPropsType {
	userList?: any;
}

const SPUserList: React.FC<TableUserListPropsType> = props => {
	const { userList } = props;
	const list: any = [];
	if (Array.isArray(userList) && userList.length) {
		userList.forEach((item: any) => {
			list.push(item.user_name);
		});
	}
	return list.length ? list.join(',') : '';
};

interface TableActionBarPropsType {
	data?: any;
	permission?: any;
}

const SPRolePermissionsTableActionBar: React.FC<TableActionBarPropsType> = props => {
	const { data, permission } = props;

	const onCorrelation = () => {
		emiter.emit(EVENT_CARRENTAL_ROLE_OPEN_EMPLOYEE, data);
	};

	const onView = () => {
		emiter.emit(EVENT_CARRENTAL_ROLE_OPEN_DETAIL, data);
	};

	return (
		<>
			<SPButton permissionKey="view-role-msg" permission={permission}  type="link" onClick={onView}>
				查看
			</SPButton>
			{/* 超级管理员只绑定一个 */}
			<SPButton permissionKey="user_role_bind_user" permission={permission}  disabled={data?.key === 'user_role_bind_user'} type="link" onClick={onCorrelation}>
				关联
			</SPButton>
		</>
	);
};

interface TableDataType {
	key?: any;
	name?: string;
	user_list?: any;
}

interface TablePropsType {
	enums?: any;
	value?: any;
	actionBar?: any;
	permission?: any;
}

const SPRolePermissionsTable: React.FC<TablePropsType> = props => {
	const { permission } = props;
	const columns: TableProps<TableDataType>['columns'] = [
		{ title: '角色名称', width: 120, dataIndex: 'name', key: 'name' },
		{ title: '绑定员工', width: 500, dataIndex: 'user_list', key: 'user_list', render: text => <SPUserList userList={text} /> },
		{
			title: '操作',
			key: 'action',
			fixed: 'right',
			// className: 'common-tab-action-bar',
			width: 220,
			render: (_, record) => <SPRolePermissionsTableActionBar permission={permission} data={record} />,
		},
	];

	const [data, setData] = useState([]);
	const [searchData, setSearchData] = useState({});
	const [totalCount, setTotalCount] = useState(0);
	const [currentPageData, setCurrentPageData] = useState<any>();

	const loadData = (params?: any) => {
		getRoleList(params).then((res: any) => {
			setData(res?.data);
			setSearchData(params);
			setTotalCount(res.data.total || 0);
			setCurrentPageData({
				pageIndex: res.data.page || params.page || 1,
				pageSize: res.data.page_size || params.page_size || 10,
			});
		});
	};

	// 分页改变
	const onPagination = (pagination: TablePaginationConfig) => {
		emiter.emit(
			EVENT_CARRENTAL_ROLE_SEARCH_LIST,
			Object.assign(searchData || {}, {
				page: pagination.current,
				page_size: pagination.pageSize,
			})
		);
	};

	useEffect(() => {
		loadData({ page: 1, page_size: 10 });
	}, []);

	useEffect(() => {
		emiter.on(EVENT_CARRENTAL_ROLE_SEARCH_LIST, loadData);
		return () => {
			emiter.removeAllListeners(EVENT_CARRENTAL_ROLE_SEARCH_LIST)
		}
	}, []);

	return (
		<Table
			size='middle'
			scroll={{ x: '100%' }}
			columns={columns}
			dataSource={data}
			rowKey={cols => cols.key}
			pagination={{
				total: totalCount,
				showSizeChanger: true,
				showQuickJumper: true,
				showTotal: total => `共 ${total} 条数据`,
				current: currentPageData?.pageIndex,
				pageSize: currentPageData?.pageSize,
			}}
			onChange={onPagination}
		/>
	);
};

export default SPRolePermissionsTable;
